import anime from 'animejs/lib/anime.es.js';
import { sliceHTMLElements } from '../../js/helpers';

const HomepageAnime = () => {
	const title = document.querySelector('.tos-homepage__title');
	const contentTextLeft = document.querySelector(
		'.tos-homepage__content-text--left',
	);
	const contentTextRight = document.querySelector(
		'.tos-homepage__content-text--right',
	);
	sliceHTMLElements(title);

	Array.from(contentTextLeft.children).forEach(element => {
		if (element) {
			sliceHTMLElements(element);
		}
	});
	Array.from(contentTextRight.children).forEach(element => {
		if (element) {
			sliceHTMLElements(element);
		}
	});

	const tl = anime.timeline({
		easing: 'easeOutExpo',
		duration: 500,
	});

	tl.add({
		targets: '.tos-homepage',
		opacity: [0, 1],
	});

	tl.add({
		targets: '.tos-homepage__title .sliced-element',
		opacity: [0, 1],
		easing: 'easeInOutQuad',
		delay: (_, i) => 50 * (i + 1),
	});

	tl.add({
		targets: '.tos__homepage-video--left .tos-video',
		opacity: [0, 1],
		duration: 2500,
	});

	tl.add(
		{
			targets: '.tos-homepage__content-text--left .sliced-element',
			opacity: [0, 1],
			delay: (_, i) => 20 * (i + 1),
			duration: 1000,
		},
		'-=1500',
	);

	tl.add(
		{
			targets: '.tos-homepage__separator .sliced-element',
			opacity: [0, 0.5],
			delay: (_, i) => 50 * (i + 1),
			duration: 1000,
		},
		'-=750',
	);

	tl.add(
		{
			targets: '.tos-homepage__separator-line',
			opacity: [0, 1],
			scale: [0, 1],
			duration: 1000,
		},
		'-=500',
	);

	tl.add(
		{
			targets: '.tos__homepage-video--right .tos-video',
			opacity: [0, 1],
			duration: 2500,
		},
		'-=750',
	);

	tl.add(
		{
			targets: '.tos-homepage__content-text--right .sliced-element',
			opacity: [0, 1],
			delay: (_, i) => 20 * (i + 1),
			duration: 1000,
		},
		'-=1500',
	);

	tl.add(
		{
			targets: '.tos-homepage__button',
			translateX: [-150, 0],
			opacity: [0, 1],
			duration: 1500,
		},
		'-=750',
	);
};

export default HomepageAnime;
